// Writes your routes here
// dashboard form
export const manualDashboardApi = 'manual-content-management/manual-dashboard/list'
// application form
export const manualCategoryListApi = 'configuration/manual-category/list'
export const manualCategoryStoreApi = 'configuration/manual-category/store'
export const manualCategoryUpdateApi = 'configuration/manual-category/update'
export const manualCategoryStatusApi = 'configuration/manual-category/toggle-status'
// Manual Information
export const manualInformationListApi = 'manual-content-management/manual-information/list'
export const manualInformationStoreApi = 'manual-content-management/manual-information/store'
export const manualInformationUpdateApi = 'manual-content-management/manual-information/update'
export const manualInformationToggleStatusApi = 'manual-content-management/manual-information/toggle-status'
export const manualInformationExistServiceApi = 'manual-content-management/manual-information/exist-service'
// service point routes
const servicePoint = 'manual-content-management/manage-service-point/'
export const servicePointList = servicePoint + 'index'
export const servicePointListApi = servicePoint + 'list'
export const servicePointStoreApi = servicePoint + 'store'
export const servicePointUpdateApi = servicePoint + 'update'
export const servicePointChangeStatusApi = servicePoint + 'toggle-status'

// Manual FAQ routes
const manualFaq = 'manual-content-management/manual-faq/'
export const manualFaqListApi = manualFaq + 'list'
export const manualFaqStoreApi = manualFaq + 'store'
export const manualFaqUpdateApi = manualFaq + 'update'
export const manualFaqChangeStatusApi = manualFaq + 'toggle-status'

// Committees routes
const committee = 'manual-content-management/committee-management/'
export const committeeGetServicePointListApi = committee + 'service-point-list'
export const committeeListApi = committee + 'list'
export const committeeStoreApi = committee + 'store'
export const committeeUpdateApi = committee + 'update'
export const committeeChangeStatusApi = committee + 'toggle-status'
// service eligibility routes
const serviceEligibility = 'manual-content-management/manage-service-eligibility/'
export const serviceEligibilityListApi = serviceEligibility + 'list'
export const serviceEligibilityStoreApi = serviceEligibility + 'store'
export const serviceEligibilityUpdateApi = serviceEligibility + 'update'
export const serviceEligibilityChangeStatusApi = serviceEligibility + 'toggle-status'
export const getServiceNames = serviceEligibility + 'get-service-names'

// service eligibility routes
const complain = 'manual-content-management/manage-complain/'
export const complainListApi = complain + 'list'
export const complainStoreApi = complain + 'store'
export const complainUpdateApi = complain + 'update'
export const complainChangeStatusApi = complain + 'toggle-status'
export const complainStatusUpdateApi = complain + 'status-update'
export const complainUpdateStatusApi = complain + 'update-status'
export const userListByDesignationApi = 'user/users-by-designation-id'
